<template>
  <b-card>
    <b-row>
      <b-col md="7" class="p-0">
        <div class="my-2 mb-4 ml-4 mr-4">
          <h1>Create Tenant</h1>
          <v-stepper alt-labels v-model="e1">
            <v-stepper-header>
              <v-stepper-step
                step="1"
                class="v-stepper-step-outline"
                style="margin-left:24px;"
                >Company</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="2" class="v-stepper-step-outline"
                >Address</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="3" class="v-stepper-step-outline"
                >Authentication</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="4" class="v-stepper-step-outline"
                >Agreement</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="5" class="v-stepper-step-outline"
                >KYC verification</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="6" class="v-stepper-step-outline"
                >Done</v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <s-organization @place_changed="setPlace">
                  <template v-slot:footer-button="data">
                    <span style="color:red;">{{ error }}</span>
                    <b-button
                      class="btn btn-block mt-3"
                      btn-color="primary"
                      @click="CompanyToNext(data.data)"
                      >Next</b-button
                    >
                  </template>
                </s-organization>
              </v-stepper-content>

              <v-stepper-content step="2">
                <s-office :tenants="tenants">
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn
                          class="mt-3"
                          flat
                          @click="e1 = 1"
                          btn-back="primary"
                        >
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <span style="color:red;">{{ error }}</span>
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AddressToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-office>
              </v-stepper-content>

              <v-stepper-content step="3">
                <s-authentication>
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 2" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <span style="color:red">{{ error }}</span>
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AuthToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-authentication>
              </v-stepper-content>

              <v-stepper-content step="4">
                <s-agreement>
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 3" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AgreementtoNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-agreement>
              </v-stepper-content>

              <v-stepper-content step="5">
                <s-kyc
                  @readKYC="KYCUpdate($event)"
                  :documentList="documentList"
                  :tenantID="currentTenant"
                >
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 4" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block btn"
                          btn-color="primary"
                          :disabled="
                            !kycChangeObj.photouploaded &&
                              !kycChangeObj.idProofuploaded &&
                              !kycChangeObj.addressProofuploaded
                          "
                          @click="AgreeToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-kyc>
              </v-stepper-content>

              <v-stepper-content step="6">
                <s-thanks @done="done"></s-thanks>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </b-col>
      <b-col md="5" col-4="image" class="p-0">
        <img src="img/svg/createAccount.svg" class="img-avatar" />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import sOffice from "@/components/Tenant/OfficeStepper.vue";
import sOrganization from "@/components/Tenant/OrganizationStepper.vue";
import sAuthentication from "@/components/Tenant/AuthenticationStepper.vue";
import sThanks from "@/components/Tenant/ThankYouStepper.vue";
import sAgreement from "@/components/Tenant/Agreement.vue";
import sKYC from "@/components/Tenant/KYC.vue";
import { getReverseGeoCode } from "@/services/geocode";

import { listTenant } from "../../services/tenant.ts";

export default {
  name: "CreateTenant",
  components: {
    sOffice,
    sOrganization,
    sAuthentication,
    sThanks,
    sAgreement,
    "s-kyc": sKYC,
    cInput
  },
  data() {
    return {
      currentTenant: null,
      e1: 0,
      tenants: [],
      kycChangeObj: {},
      company: null,
      address: null,
      authentication: null,
      agreement: null,
      documentList: null,
      error: null
    };
  },
  methods: {
    async CompanyToNext(item) {
      console.log(item);
      if (item.name != "" && item.logo != "") {
        this.company = item;
        this.e1 = 2;
        this.error = "";
      } else {
        this.error = "Fill the details";
      }
    },
    async AddressToNext(item) {
      if (
        item.address.city != "" &&
        item.address.country != "" &&
        item.address.state != "" &&
        item.address.zip != "" &&
        item.address.houseNumber != "" &&
        item.address.street1 != "" &&
        item.address.street2 != ""
      ) {
        this.address = item.address;
        try {
          const data = await getReverseGeoCode(
            `${this.address.street1},${this.address.city},${this.address.state},${this.address.country}`
          );
          if (data.data.status === "OK") {
            this.address.location.coordinates = [
              data.data.results[0].geometry.location.lng,
              data.data.results[0].geometry.location.lat
            ];
          }

          this.e1 = 3;
          this.error = "";
          console.log("geocoderesult", data);
        } catch (error) {}
      } else {
        this.error = "Fill the details";
      }
    },
    async AuthToNext(item) {
      console.log(item);
      this.error = "";
      const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (
        (item.phone != "" &&
          item.email != "" &&
          item.userName != "" &&
          item.password != "" &&
          item.confirmpassword != "" &&
          item.firstName != "") ||
        item.lastName != ""
      ) {
        if (re.test(String(item.email).toLowerCase()) == false) {
          this.error = "Enter valid email id";
        } else if (item.password != item.confirmpassword) {
          this.error = "Password and confirm password should be same";
        } else {
          this.authentication = item;
          this.error = "";
          this.e1 = 4;
        }
        console.log(this.error);
      } else {
        this.error = "Fill the details";
      }
    },
    async AgreementtoNext(item) {
      this.error = "";
      if (item.doc != "" && item.market.value != "" && item.keys.value != "") {
        this.agreement = item;
        const { address, company, authentication, agreement } = this;
        let agreementData = [];
        agreement.catalog.map(obj => {
          agreementData.push({
            categoryType: agreement.market.value,
            catalogId: obj._id
          });
        });
        let agreementPayload = {
          doc: agreement.doc,
          valid: agreement.valid,
          businessSegmentInfo: agreementData
        };

        const payload = {
          authentication: {
            email: authentication.email,
            userName: authentication.userName,
            password: authentication.password,
            phone: authentication.phone
          },
          name: {
            first: authentication.firstName,
            last: authentication.lastName
          },
          agreement: agreementPayload,
          preferences: {
            enableManufacturer: item.enableManufacturer
              ? item.enableManufacturer
              : false
          },
          company,
          address
        };
        console.log(payload);

        this.$store
          .dispatch("tenant/createTenant", payload)
          .then(async result => {
            console.log("result : ", result);
            this.currentTenant = result.response._id;
            let payloadPref = {
              id: this.currentTenant,
              data: {
                paymentMethod: {
                  cod: agreement.paymentOptionKeys.includes("COD"),
                  online: agreement.paymentOptionKeys.includes(
                    "CASHFREE",
                    "PAYTM"
                  )
                }
              }
            };

            await this.$store
              .dispatch("tenant/updateTenantPreferences", payloadPref)
              .then(result => {})
              .catch(err => {});
            if (agreement.paymentOptionKeys.includes("CASHFREE", "PAYTM")) {
              let payloadFinalConfig = {
                id: this.currentTenant,
                data: {
                  category: "TA"
                }
              };
              if (agreement.paymentOptionKeys.includes("CASHFREE")) {
                payloadFinalConfig.data.cashfree = {
                  appId: agreement.appkeyCashFree,
                  secretKey: agreement.secretkeyCashFree
                };
              }
              if (agreement.paymentOptionKeys.includes("PAYTM")) {
                payloadFinalConfig.data.paytm = {
                  appId: agreement.appkeyPaytm,
                  secretKey: agreement.secretkeyPaytm
                };
              }
              await this.$store
                .dispatch("tenant/setPaymentConfigAction", payloadFinalConfig)
                .then(result => {
                  this.$swal({
                    title: "Success",
                    text: "Tenant details submitted successfully!",
                    type: "success"
                  });
                  this.e1 = 5;
                })
                .catch(err => {
                  this.$swal({
                    title: "Error",
                    text: "Could not create Tenant",
                    type: "error"
                  });
                });
            } else {
              this.$swal({
                title: "Success",
                text: "Tenant details submitted successfully!",
                type: "success"
              });
              this.e1 = 5;
            }
          })
          .catch(error => {
            this.$swal({
              title: "Error",
              text: "Could not create Tenant",
              type: "error"
            });
          });
      } else {
        this.error = "Fill the details";
      }
    },
    AgreeToNext(item) {
      let dataObj = {
        tenantId: this.currentTenant,
        status: "SUBMIT"
      };
      this.$store.dispatch("tenant/submitKYCByTenant", dataObj).then(result => {
        this.e1 = 6;
      });
    },
    done() {
      this.$router.push({ path: "/tenant" });
    },
    async setPlace(p) {
      let place = await p;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.position = position;
    },
    async getKYCList() {
      this.currentTenant = "5ec257652872e3197f808af8";
      console.log(this.currentTenant);
      this.$store
        .dispatch("tenant/fetchKYCListByTenant", this.currentTenant)
        .then(result => {
          this.documentList = result.response;
          console.log("documentLIST", this.documentList);
        });
    },
    KYCUpdate(event) {
      this.kycChangeObj = event;
      console.log("event", event);
    }
  },
  mounted: async function() {
    // this.getKYCList();
    // this.e1 = 5;
    // const { response: tenants } = await listTenant();
    // this.tenants = tenants;
    // console.log("tenants : ", tenants);
  }
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  margin-top: 150px !important;
}
</style>
<style>
.v-stepper {
  box-shadow: none;
  /* padding: 19px; */
}

.v-stepper__header {
  box-shadow: none;
}

.v-btn:before {
  opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 0px;
}

.v-stepper-step-outline {
  border: 1px solid #727cf5 !important;
  height: 0px;
  border-radius: 50%;
  width: 0px;
  margin-top: 8px;
  /* margin-right: 0px; */
  /* margin-left: 0; */
  margin-bottom: 40px;
  float: left;
}
@-moz-document url-prefix() {
  .v-stepper-step-outline {
    padding: 24px 4px 24px 4px;
  }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
  color: #ffffff;
  background-color: #727cf5 !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
  margin-right: 0;
  margin-bottom: 22px;
  margin-top: -21px;
}
.v-stepper__step__step {
  min-height: 42px;
  min-width: 42px !important;
}
.v-stepper__content {
  padding: 0px !important;
  margin-top: 25px;
}
/* Deactive Stepper */
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: #8badd6 !important;
}
/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px 0px;
  -ms-flex-item-align: start;
  align-self: flex-start;
}
.btn {
  height: 41px;
  background-color: #727cf5;
  font-weight: bolder;
  font-size: 10px;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}
</style>
